<template>
    <div class="flex justify-center sm:justify-between items-center gap-md" v-show="totalPages > 1">
        <div class="w-3xl sm:flex justify-start hidden">
            <a href="#" class="btn btn--primary btn--outline" v-show="currentPage > 1" @click.prevent="$emit('previous-page')"> Vorige </a>
        </div>
        <div class="flex items-center justify-center gap-xxs">
            <span
                v-for="i in totalPages"
                :key="i"
                class="font-semibold text-gray-500 w-md h-md bg-transparent cursor-pointer flex items-center justify-center hover:bg-gray-700"
                :class="{
                    'bg-primary-400 text-gray-900': i === currentPage,
                }"
                @click.prevent="$emit('go-to-page', { page: i })"
                v-show="i < currentPage + 5 && i > currentPage - 5"
            >
                {{ i }}
            </span>
        </div>
        <div class="w-3xl hidden sm:flex justify-end">
            <a href="#" class="btn btn--primary btn--outline" v-show="currentPage < totalPages" @click.prevent="$emit('next-page')"> Volgende </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pagination',

    props: {
        totalPages: {
            type: Number,
            required: true,
        },

        currentPage: {
            type: Number,
            required: true,
        },
    },
};
</script>
